// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13VIa","colBig":"styles_colBig__3f6cm","colSmall":"styles_colSmall__1dh55","shopifyNameWrapper":"styles_shopifyNameWrapper__2t4vF"};